(function () {
  'use strict';
  var groupKeys = ['perf', 'gen', 'casa'];

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function hasSelections(selection) {
    return groupKeys.some(function (group) { return selection[group].size > 0; });
  }
  function matchesRecord(record, selection, aliases, onlyPerf) {
    return (onlyPerf ? ['perf'] : groupKeys).every(function (group) {
      var values = selection[group];
      if (!values.size) return true;
      if (group === 'casa') return values.has(record.houseKey);
      return Array.from(values).some(function (value) {
        return (aliases[group][value] || []).some(function (tag) { return record.tags.has(tag); });
      });
    });
  }
  function selectionUrl(currentUrl, selection, nativePage) {
    var destination = new URL(currentUrl);
    groupKeys.forEach(function (group) {
      var name = 'alp_' + group;
      if (selection[group].size) destination.searchParams.set(name, Array.from(selection[group]).join(','));
      else destination.searchParams.delete(name);
    });
    if (!hasSelections(selection) && nativePage) destination.searchParams.set('page', nativePage);
    else destination.searchParams.delete('page');
    return destination;
  }
  function catalogUrl(collectionUrl, currentUrl, sectionId) {
    var current = new URL(currentUrl);
    var destination = new URL(collectionUrl, current);
    if (destination.origin !== current.origin) throw new Error('Invalid collection origin');
    var collectionPath = destination.pathname.replace(/\/$/, '');
    if (current.pathname === collectionPath || current.pathname.indexOf(collectionPath + '/') === 0) destination.pathname = current.pathname;
    destination.search = '';
    current.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'preview_theme_id') destination.searchParams.append(key, value);
    });
    destination.searchParams.set('section_id', sectionId);
    destination.hash = '';
    return destination;
  }
  function validatedNext(next, first) {
    var destination = new URL(next, first);
    if (destination.origin !== first.origin || destination.pathname.replace(/\/$/, '') !== first.pathname.replace(/\/$/, '')) throw new Error('Invalid catalog continuation');
    var protectedKeys = new Set();
    first.searchParams.forEach(function (_, key) { protectedKeys.add(key); });
    Array.from(destination.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'preview_theme_id' || key === 'section_id') destination.searchParams.delete(key);
    });
    protectedKeys.forEach(function (key) {
      destination.searchParams.delete(key);
      first.searchParams.getAll(key).forEach(function (value) { destination.searchParams.append(key, value); });
    });
    destination.hash = '';
    return destination;
  }
  function createCatalogLoader(firstUrl, loadPage) {
    var cachedPromise = null;
    return function () {
      if (cachedPromise) return cachedPromise;
      cachedPromise = (async function () {
        var first = new URL(firstUrl);
        var next = first;
        var seenPages = new Set();
        var seenProducts = new Set();
        var records = [];
        while (next) {
          if (seenPages.has(next.href)) throw new Error('Repeated catalog page');
          seenPages.add(next.href);
          var page = await loadPage(next.href);
          if (!page || !Array.isArray(page.records)) throw new Error('Invalid catalog response');
          page.records.forEach(function (record) {
            if (record.id && seenProducts.has(record.id)) return;
            if (record.id) seenProducts.add(record.id);
            records.push(record);
          });
          next = page.next ? validatedNext(page.next, first) : null;
        }
        return records;
      })().catch(function (error) {
        cachedPromise = null;
        throw error;
      });
      return cachedPromise;
    };
  }

  /* Export the production rules for local logic checks without a browser dependency. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalize: normalize, matchesRecord: matchesRecord, selectionUrl: selectionUrl, catalogUrl: catalogUrl, validatedNext: validatedNext, createCatalogLoader: createCatalogLoader };
    return;
  }
  if (window.__alpOccasions) return;
  window.__alpOccasions = true;
  var initialized = new WeakSet();

  function initGroups(root) {
    var groups = root.querySelector('[data-aoc-groups]');
    var nativeResults = root.querySelector('[data-aoc-native-results]');
    var results = root.querySelector('[data-aoc-group-results]');
    var grid = root.querySelector('[data-aoc-filtered-grid]');
    var more = root.querySelector('[data-aoc-more]');
    var count = root.querySelector('.aoc-count');
    var status = root.querySelector('[data-aoc-status]');
    var chips = root.querySelector('[data-aoc-group-active]');
    var clear = root.querySelector('[data-aoc-groups-clear]');
    var empty = root.querySelector('[data-aoc-group-empty]');
    var houseOptions = root.querySelector('[data-aoc-house-options]');
    var houseSearch = root.querySelector('[data-aoc-house-search]');
    var houseEmpty = root.querySelector('[data-aoc-house-empty]');
    if (!groups || !nativeResults || !results || !grid || !count || !status || !chips || !clear || !empty || !houseOptions) return;

    var originalCount = count.textContent;
    var selection = { perf: new Set(), gen: new Set(), casa: new Set() };
    var aliases = { perf: {}, gen: {} };
    var labels = { perf: {}, gen: {}, casa: {} };
    var params = new URLSearchParams(window.location.search);
    var nativePage = params.get('page');
    var records = null;
    var filtered = [];
    var displayed = 0;
    var generation = 0;
    var housesBuilt = false;
    groups.querySelectorAll('input[data-aoc-group]').forEach(function (input) {
      var group = input.dataset.group;
      var key = normalize(input.value);
      if (group !== 'perf' && group !== 'gen') return;
      input.value = key;
      aliases[group][key] = (input.dataset.tags || '').split(',').map(normalize).filter(Boolean);
      labels[group][key] = input.dataset.label || input.closest('label').textContent.trim();
    });
    groupKeys.forEach(function (group) {
      (params.get('alp_' + group) || '').split(',').map(normalize).filter(Boolean).forEach(function (key) {
        if (group === 'casa' || Object.prototype.hasOwnProperty.call(aliases[group], key)) selection[group].add(key);
      });
    });

    function textFor(name, fallback) { return groups.dataset[name] || fallback; }
    function setStatus(message, isError) {
      status.textContent = message;
      status.hidden = !message;
      status.classList.toggle('is-error', Boolean(isError));
      status.setAttribute('role', isError ? 'alert' : 'status');
    }
    function syncInputs() {
      groups.querySelectorAll('input[data-aoc-group]').forEach(function (input) {
        input.checked = Boolean(selection[input.dataset.group] && selection[input.dataset.group].has(normalize(input.value)));
      });
    }
    function persist() {
      var destination = selectionUrl(window.location.href, selection, nativePage);
      window.history.replaceState(window.history.state, '', destination.href);
    }
    function renderChips() {
      chips.replaceChildren();
      groupKeys.forEach(function (group) {
        selection[group].forEach(function (key) {
          var label = labels[group][key] || key.replace(/-/g, ' ');
          var item = document.createElement(chips.tagName === 'UL' ? 'li' : 'span');
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'aoc-group-chip';
          button.dataset.aocRemoveGroup = group;
          button.dataset.value = key;
          button.textContent = label + ' ×';
          button.setAttribute('aria-label', textFor('removeLabel', 'Quitar {label}').replace('{label}', label));
          item.appendChild(button);
          chips.appendChild(item);
        });
      });
      chips.hidden = !hasSelections(selection);
      clear.hidden = !hasSelections(selection);
      groups.querySelectorAll('[data-aoc-group-count]').forEach(function (badge) {
        var total = selection[badge.dataset.aocGroupCount].size;
        badge.textContent = String(total);
        badge.hidden = total === 0;
      });
    }
    function restoreNative() {
      nativeResults.hidden = false;
      results.hidden = true;
      empty.hidden = true;
      if (more) more.hidden = true;
      count.textContent = originalCount;
    }
    function updateHouses(pruneSelection) {
      if (!records) return false;
      if (!housesBuilt) {
        records.forEach(function (record) {
          if (record.houseKey && record.houseLabel) labels.casa[record.houseKey] = record.houseLabel;
        });
        Object.keys(labels.casa).sort(function (a, b) { return labels.casa[a].localeCompare(labels.casa[b], document.documentElement.lang || 'es', { sensitivity: 'base' }); }).forEach(function (key) {
          var label = document.createElement('label');
          label.className = 'aoc-group-option';
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.value = key;
          input.dataset.aocGroup = '';
          input.dataset.group = 'casa';
          input.dataset.label = labels.casa[key];
          var name = document.createElement('span');
          name.textContent = labels.casa[key];
          label.append(input, name);
          houseOptions.appendChild(label);
        });
        housesBuilt = true;
      }
      var available = new Set(records.filter(function (record) { return matchesRecord(record, selection, aliases, true); }).map(function (record) { return record.houseKey; }));
      var pruned = false;
      if (pruneSelection === true) selection.casa.forEach(function (key) {
        if (!available.has(key)) { selection.casa.delete(key); pruned = true; }
      });
      var query = normalize(houseSearch ? houseSearch.value : '');
      var visible = 0;
      houseOptions.querySelectorAll('input[data-aoc-group]').forEach(function (input) {
        input.checked = selection.casa.has(input.value);
        var show = input.checked || (available.has(input.value) && (!query || normalize(labels.casa[input.value]).indexOf(query) !== -1));
        input.closest('.aoc-group-option').hidden = !show;
        if (show) visible += 1;
      });
      if (houseEmpty) {
        houseEmpty.textContent = textFor('houseEmptyLabel', 'No encontramos esa casa.');
        houseEmpty.hidden = visible !== 0;
      }
      return pruned;
    }
    function appendBatch(focusNew) {
      var fragment = document.createDocumentFragment();
      var end = Math.min(displayed + 24, filtered.length);
      var firstNew = null;
      for (var index = displayed; index < end; index += 1) {
        var card = filtered[index].node.cloneNode(true);
        if (!firstNew) firstNew = card;
        fragment.appendChild(card);
      }
      displayed = end;
      grid.appendChild(fragment);
      if (more) more.hidden = displayed >= filtered.length;
      if (focusNew && firstNew) {
        var link = firstNew.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      }
    }

    var loadCatalog = createCatalogLoader(catalogUrl(groups.dataset.collectionUrl, window.location.href, groups.dataset.sectionId || 'alp-occasion-filter-catalog').href, async function (url) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: controller.signal });
        if (!response.ok) throw new Error('Catalog HTTP ' + response.status);
        var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        var catalog = parsed.querySelector('[data-aoc-catalog]');
        if (!catalog) throw new Error('Missing catalog section');
        var pageRecords = Array.from(catalog.querySelectorAll('[data-aoc-record]')).map(function (node) {
          var tags = JSON.parse(node.dataset.tags || '[]');
          if (!Array.isArray(tags)) throw new Error('Invalid product tags');
          node.querySelectorAll('script').forEach(function (script) { script.remove(); });
          var productLink = node.querySelector('a[href]');
          return {
            id: node.dataset.productId || (productLink ? productLink.getAttribute('href') : ''),
            tags: new Set(tags.map(normalize)),
            houseKey: normalize(node.dataset.houseKey),
            houseLabel: node.dataset.houseLabel || '',
            node: node
          };
        });
        return { records: pageRecords, next: catalog.dataset.next || '' };
      } finally { window.clearTimeout(timeout); }
    });

    async function update(forceLoad, shouldPersist, pruneHouses) {
      var ticket = ++generation;
      var pruned = records ? updateHouses(pruneHouses) : false;
      syncInputs();
      if (shouldPersist || pruned) persist();
      renderChips();
      if (!hasSelections(selection) && !forceLoad) {
        restoreNative();
        setStatus('');
        return;
      }
      if (!records) {
        var loadingMessage = textFor('loadingLabel', 'Cargando perfumes…');
        setStatus(loadingMessage);
        if (houseEmpty) { houseEmpty.textContent = loadingMessage; houseEmpty.hidden = false; }
      }
      try {
        var fetched = records || await loadCatalog();
        if (ticket !== generation || !root.isConnected) return;
        records = fetched;
        pruned = updateHouses(pruneHouses);
        syncInputs();
        if (shouldPersist || pruned) persist();
        renderChips();
        if (!hasSelections(selection)) {
          restoreNative();
          setStatus('');
          return;
        }
        filtered = records.filter(function (record) { return matchesRecord(record, selection, aliases, false); });
        displayed = 0;
        grid.replaceChildren();
        appendBatch(false);
        nativeResults.hidden = true;
        results.hidden = false;
        empty.hidden = filtered.length !== 0;
        var countLabel = textFor(filtered.length === 1 ? 'countSingular' : 'countPlural', filtered.length === 1 ? '{count} perfume' : '{count} perfumes');
        count.textContent = countLabel.replace('{count}', String(filtered.length));
        setStatus(count.textContent);
      } catch (_) {
        if (ticket !== generation || !root.isConnected) return;
        restoreNative();
        var errorMessage = textFor('errorLabel', 'No pudimos cargar estos filtros. Inténtalo de nuevo; puedes seguir explorando la colección.');
        setStatus(errorMessage, true);
        if (houseEmpty) { houseEmpty.textContent = errorMessage; houseEmpty.hidden = false; }
      }
    }
    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('input[data-aoc-group]')) return;
      var group = input.dataset.group;
      if (groupKeys.indexOf(group) === -1) return;
      var key = normalize(input.value);
      if (input.checked) selection[group].add(key);
      else selection[group].delete(key);
      update(false, true, group === 'perf');
    });
    root.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-aoc-remove-group]');
      if (remove && root.contains(remove)) {
        selection[remove.dataset.aocRemoveGroup].delete(remove.dataset.value);
        update(false, true);
      } else if (event.target.closest('[data-aoc-groups-clear]')) {
        groupKeys.forEach(function (group) { selection[group].clear(); });
        update(false, true);
      } else if (event.target.closest('[data-aoc-more]')) appendBatch(true);
    });
    var housePanel = groups.querySelector('[data-aoc-group-panel="casa"]');
    var panels = Array.from(groups.querySelectorAll('[data-aoc-group-panel]'));
    panels.forEach(function (panel) {
      panel.addEventListener('toggle', function () {
        if (!panel.open) return;
        panels.forEach(function (other) { if (other !== panel) other.open = false; });
        if (panel === housePanel) update(true, false);
      });
    });
    if (houseSearch) {
      houseSearch.addEventListener('focus', function () { if (!records) update(true, false); });
      houseSearch.addEventListener('input', function () { updateHouses(false); });
    }
    syncInputs();
    groups.hidden = false;
    if (hasSelections(selection)) update(false, true);
  }

  function enhance(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-aoc-page]'));
    if (scope.matches && scope.matches('[data-aoc-page]')) roots.unshift(scope);
    roots.forEach(function (root) {
      root.classList.add('aoc-enhanced');
      if (initialized.has(root)) return;
      initialized.add(root);
      initGroups(root);
    });
  }
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-aoc-sort]') || !select.closest('.alp-occasions')) return;
    var destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', select.value);
    destination.searchParams.delete('page');
    destination.hash = 'aoc-products';
    window.location.assign(destination.href);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-aoc-filter-form], [data-aoc-sort-form]')) return;
    var params = new URLSearchParams(window.location.search);
    ['preview_theme_id', 'alp_perf', 'alp_gen', 'alp_casa'].forEach(function (name) {
      form.querySelectorAll('input[name="' + name + '"]').forEach(function (input) { input.remove(); });
      var value = params.get(name);
      if (!value) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
  });
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  document.addEventListener('click', function (event) {
    if (event.target.closest('.aoc-group-row')) return;
    document.querySelectorAll('[data-aoc-page] [data-aoc-group-panel][open]').forEach(function (panel) { panel.open = false; });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-aoc-page] [data-aoc-group-panel][open]').forEach(function (panel) {
      var hadFocus = panel.contains(document.activeElement);
      panel.open = false;
      if (hadFocus) panel.querySelector('summary').focus();
    });
  });
  window.addEventListener('popstate', function () { if (document.querySelector('[data-aoc-page]')) window.location.reload(); });
  enhance(document);
})();
